/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Upload, Tooltip } from "antd";
import { Avatar } from "primereact/avatar";
import Linkify from "react-linkify";
import moment from "moment";
import {
    addProjectComment,
    downloadAttachments,
    downloadAllAttachments,
    deleteProjectComment,
    updateProjectComment
} from "../../../../apis/projectCommentApis";
import {
    checkUserRole,
    conditionDeleteComment
} from "../../../../utils/constants";
import { downloadedFile, downloadFileUrl } from "../../../../functions/functions";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles


const CommentComponent = (props) => {
    const [commentsImagesMap, setCommentsImagesMap] = useState(new Map());
    const [commentValue, setCommentValue] = useState("");
    const [commentValueExpand, setCommentValueExpand] = useState("");
    const [attachmentfileList, setAttachmentFileList] = useState([]);
    const [apiLoading, setApiLoading] = useState(false);
    const [addCommentDialogVisible, setAddCommentDialogVisible] = useState(false);
    const [showListCommentDialogVisible, setShowListCommentDialogVisible] = useState(false);
    const [commentToFocus, setCommentToFocus] = useState(null);
    const [unreadCount, setUnreadCount] = useState(0);

    const commentRefs = useRef({});

    const scrollContainerRef = useRef(null);
    const [hiddenCount, setHiddenCount] = useState(0);

    const baseUrl = process.env.REACT_APP_APP_MEDIA_URL_PREFIX;;
    const imageExtensions = ["jpg", "jpeg", "png"];
    const ATTACHMENT_DELIMITER = " ; ";

    const processedComments = (props.projectComments || []).map(comment => {
        const attachmentNames = comment.attachmentName || "";
      
        const attachments = attachmentNames
          .split(";")
          .map(name => name.trim())
          .filter(name => name.length > 0)
          .map(name => {
            const fileUrl = `${baseUrl}/${props.project.id}/attachments/${encodeURIComponent(name)}`;
            const ext = name.split(".").pop().toLowerCase();
            const isImage = imageExtensions.includes(ext);
            return {
              name,
              url: fileUrl,
              isImage
            };
          });
        return {
          ...comment,
          attachments
        };
      });

    useEffect(() => {
        if (!props.currentUser || !props.projectComments) return;

        const count = props.projectComments.filter(comment => checkReadComment(comment) === false).length;

        setUnreadCount(count);
    }, [props.projectComments, props.currentUser]);


    useEffect(() => {
        const handleScroll = () => {
            if (!scrollContainerRef.current) return;

            const container = scrollContainerRef.current;
            const containerRect = container.getBoundingClientRect();
            let hidden = 0;

            props.projectComments.forEach((comment) => {
                const el = commentRefs.current[comment.id];
                if (el) {
                    const elRect = el.getBoundingClientRect();

                    // Fully below container
                    if (elRect.top >= containerRect.bottom) {
                        hidden++;
                    }
                }
            });

            setHiddenCount(hidden);
        };

        const container = scrollContainerRef.current;
        container?.addEventListener("scroll", handleScroll);

        // Initial check
        handleScroll();

        return () => container?.removeEventListener("scroll", handleScroll);
    }, [props.projectComments]);

    useEffect(() => {
        if (props.isExpand && props.commentToFocus?.id && commentRefs.current[props.commentToFocus?.id]) {
            commentRefs.current[props.commentToFocus.id].scrollIntoView({
                behavior: "auto",     // 👈 No animation
                block: "start"        // 👈 Align to top of container
            });
        }
    }, [props.isExpand, props.commentToFocus]);

    const handleDeleteComment = (id) => {
        setApiLoading(true);
        deleteProjectComment(id)
            .then((res) => {
                console.log(JSON.stringify(res.status))
                if (res.status === 200) {
                    //todo reload comment
                    props.fetchProject();
                    props.toast.current.show({
                        severity: "success",
                        summary: "Status",
                        detail: "Delete project comment successfully",
                        life: 3000,
                    });
                    setApiLoading(false);
                } else {
                    props.toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: "Delete project comment fail",
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                props.toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    }

    const handleUpdateProjectComment = (comment) => {
        if(checkReadComment(comment)){
            return;
        }
        setApiLoading(true);
        updateProjectComment({id: comment.id})
            .then((res) => {
                console.log(JSON.stringify(res.status))
                if (res.status === 200) {
                    //todo reload comment
                    props.fetchProject();
                    setApiLoading(false);
                } else {
                    props.toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: "Update read project comment fail",
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                props.toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    }

    const handleDownloadAllAttachment = (commentId) => {
        if (props.project && props.project.id) {
            setApiLoading(true);
            let newValues = {
                commentId: commentId,
                projectId: `${props.project.id}`,
            };

            
            downloadAllAttachments(newValues)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("res.data", res.data);
                        downloadFileUrl(res.data);
                        setApiLoading(false);
                    } else {
                        props.toast.current.show({
                            severity: "error",
                            summary: "Status",
                            detail: "Attachment File not found",
                            life: 3000,
                        });
                        setApiLoading(false);
                    }
                })
                .catch((e) => {
                    props.toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: e,
                        life: 3000,
                    });
                    setApiLoading(false);
                });
        } else {
            props.toast.current.show({
                severity: "warn",
                summary: "Status",
                detail: "No Selected Project",
                life: 3000,
            });
        }
    };

    const handleDownloadAttachment = (name) => {
        if (props.project && props.project.id) {
            setApiLoading(true);
            let newValues = {
                fileName: name,
                projectId: `${props.project.id}`,
            };
            downloadAttachments(newValues)
                .then((res) => {
                    if (res.status === 200) {
                        downloadedFile(res, name);
                        setApiLoading(false);
                    } else {
                        props.toast.current.show({
                            severity: "error",
                            summary: "Status",
                            detail: "Attachment File not found",
                            life: 3000,
                        });
                        setApiLoading(false);
                    }
                })
                .catch((e) => {
                    props.toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: e,
                        life: 3000,
                    });
                    setApiLoading(false);
                });
        } else {
            props.toast.current.show({
                severity: "warn",
                summary: "Status",
                detail: "No Selected Project",
                life: 3000,
            });
        }
    };

    const handleCommentSave = (comment) => {
        if (
            (commentValue && commentValue.length > 0) ||
            (commentValueExpand && commentValueExpand.length > 0) ||
            (attachmentfileList && attachmentfileList.length > 0)
        ) {
            setApiLoading(true);
            let newVales = {
                comment: comment,
                feedback: props.feedback,
                project: {
                    id: props.project.id,
                },
            };
            let formData = new FormData();

            attachmentfileList.forEach((file) => {
                formData.append("files", file); // "files" is the key expected by your backend
            });
            formData.append("commentData", JSON.stringify(newVales));
            addProjectComment(formData)
                .then((res) => {
                    if (res.status === 200) {
                        setCommentValue("");
                        setCommentValueExpand("");
                        setAttachmentFileList([]);
                        props.fetchProject();
                        setApiLoading(false);
                    } else {
                        props.toast.current.show({
                            severity: "error",
                            summary: "Status",
                            detail: res.response.data,
                            life: 3000,
                        });
                        setApiLoading(false);
                    }
                    setAddCommentDialogVisible(false);
                })
                .catch((e) => {
                    props.toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: e,
                        life: 3000,
                    });
                    setApiLoading(false);
                });
        } else {
            props.toast.current.show({
                severity: "warn",
                summary: "Status",
                detail: "Cannot Send a Empty Comment",
                life: 3000,
            });
        }
    };

    const checkReadComment = (comment) => {
        if (comment.feedback){
            return true;
        }
        if(props.currentUser != null){
            const createdByYourSelf = comment.createdBy?.id === props.currentUser.id;
            const readByCurrentUser =
                comment.users?.some(user => user.id === props.currentUser.id);
            return createdByYourSelf || readByCurrentUser;
        }
    }

    const hasHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str); // Checks for any HTML tag

    return (
        <React.Fragment>
            <div>
                <div className="flex justify-content-between">
                    <h5 className="font-bold">{props.title}</h5>
                    {unreadCount > 0 && (
                        <p style={{ color: "red" }}>
                            {unreadCount} unread {unreadCount === 1 ? 'comment' : 'comments'}
                        </p>
                    )}
                </div>

                <div className="col-24">
                    {/* User comments start here */}
                                        
                    <div className="flex flex-column">
                        <div
                            ref={scrollContainerRef}
                            className="scrollbar scrollbar-pink bordered-pink thin force-overflow"
                            style={{
                                height: props.height,
                                overflowX: "hidden",
                                overflowY: "revert",
                                marginBottom: "2rem",
                                paddingLeft: "1px",
                                paddingRight: "7px",
                            }}
                        >
                            {processedComments.map((comment) => (
                                <React.Fragment>
                                    <div
                                        ref={(el) => (commentRefs.current[comment.id] = el)}
                                        className="card p-fluid mt-2 mb-2">
                                        <div className="field grid">
                                            <div
                                                className="col-20 md:col-18"
                                                style={{ width: "100%" }}
                                            >
                                                <div className="flex justify-content-between">
                                                    <div className="flex">
                                                        <Avatar
                                                            label={comment?.createdBy?.name
                                                                ?.charAt(0)
                                                                .toUpperCase()}
                                                            className="mr-2"
                                                            size="large"
                                                            shape="circle"
                                                            aria-haspopup
                                                            aria-controls="overlay_panel"
                                                            style={{
                                                                backgroundColor: checkUserRole(
                                                                    comment?.createdBy
                                                                )
                                                                    ? checkUserRole(comment?.createdBy)
                                                                    : "",
                                                                color: "#ffffff",
                                                            }}
                                                        />
                                                        <div className="ml-1">
                                                            <h6 className="font-bold m-0">
                                                                {comment && comment.createdBy
                                                                    ? comment.createdBy.name
                                                                    : ""}
                                                            </h6>
                                                            <small className="font-bold m-0">
                                                                {comment &&
                                                                    comment.createdBy &&
                                                                    comment.createdBy.userType
                                                                    ? comment.createdBy.userType
                                                                    : ""}
                                                            </small>
                                                        </div>
                                                        <div className="flex gap-1">
                                                            {comment && comment.attachmentName ? (
                                                                <React.Fragment>
                                                                    <div>
                                                                        <Tooltip title="Download Attachment">
                                                                            <Button
                                                                                icon="pi pi-paperclip text-xl"
                                                                                className="p-button-secondary p-button-text"
                                                                                aria-label="Upload"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if(comment.attachmentName.includes(ATTACHMENT_DELIMITER)){
                                                                                        handleDownloadAllAttachment(
                                                                                            comment.id,
                                                                                        );
                                                                                    } else{
                                                                                        handleDownloadAttachment(
                                                                                            comment.attachmentName,)
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                        
                                                                    </div>
                                                                </React.Fragment>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex">
                                                        {commentsImagesMap.has(
                                                            comment.attachmentName
                                                        ) ? (
                                                            <div style={{ maxWidth: "200px", width: "100%", display: "block" }}>
                                                                <Image
                                                                    preview={{ visible: false }}
                                                                    width="100%"
                                                                    src={URL.createObjectURL(
                                                                        commentsImagesMap.get(
                                                                            comment.attachmentName
                                                                        )
                                                                    )}
                                                                />
                                                            </div>

                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                    <div className="flex">
                                                        <small>
                                                            {comment? (
                                                                <React.Fragment>
                                                                    <div>
                                                                        {moment(
                                                                            comment.createdOn
                                                                        ).format("MM/DD/YYYY")}
                                                                        <br />
                                                                        {moment(
                                                                            comment.createdOn
                                                                        ).format("hh:mm a")}
                                                                    </div>
                                                                    <div>
                                                                        {props.isExpand ? <></> :
                                                                            <Button
                                                                                icon="pi pi-arrows-h text-xl"
                                                                                className="p-button-rounded p-button-secondary p-button-text"
                                                                                aria-label="Show"
                                                                                onClick={(e) => {
                                                                                    setCommentToFocus(comment); // 👈 set the focused comment ID
                                                                                    setShowListCommentDialogVisible(true);
                                                                                    handleUpdateProjectComment(comment);
                                                                                }}
                                                                            />
                                                                        }

                                                                        {conditionDeleteComment(props.permissions) ?
                                                                            <Button
                                                                                icon="pi pi-trash"
                                                                                className="p-button-rounded p-button-secondary p-button-text"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    confirmDialog({
                                                                                        message: "Are you sure you want to remove this comment?",
                                                                                        header: "Confirmation",
                                                                                        icon: "pi pi-exclamation-triangle",
                                                                                        accept: () => handleDeleteComment(comment.id),
                                                                                    });
                                                                                }}
                                                                            /> : ""}
                                                                        
                                                                        {!checkReadComment(comment) && 
                                                                            <Button
                                                                                icon="pi pi-circle-fill"
                                                                                className="p-button-rounded p-button-secondary p-button-text"
                                                                                style={{color: "red"}}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </React.Fragment>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </small>
                                                    </div>
                                                </div>
                                                <p
                                                    className="ml-1 mr-1 mt-1"
                                                    style={
                                                        props.isExpand
                                                            ? {} // Full view — no height restriction
                                                            : {
                                                                overflowWrap: "anywhere",
                                                                maxHeight: "100px",
                                                                overflowY: "auto"
                                                            }
                                                    }
                                                >
                                                    {comment.attachments?.length > 0 ? <>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap", // Enables wrapping
                                                                gap: "5px",       // Optional: spacing between images
                                                                marginBottom: "8px",
                                                            }}
                                                        >                                                            {comment.attachments?.map((attachment, index) => (
                                                            <div key={index} style={{ textAlign: "center" }}>
                                                                {attachment.isImage ? (
                                                                    <div style={{ width: props.isExpand ? "100%" : "200px", height: "auto", display: "block" }}>
                                                                        <Image
                                                                            preview={{ visible: false }}
                                                                            width="100%"
                                                                            src={attachment.url}
                                                                            onError={(e) => (e.target.style.display = 'none')}
                                                                        />
                                                                    </div>
                                                                ) : ("")}
                                                            </div>
                                                        ))}
                                                            <br></br>
                                                        </div>

                                                        <div style={{ display: "block", alignItems: "left" }}>
                                                            {comment.attachments?.map((attachment, index) => (
                                                                <div key={index} style={{ textAlign: "left" }}>
                                                                    {!attachment.isImage ? (
                                                                        <a
                                                                            href={attachment.url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                height: "auto",
                                                                                fontSize: "10px",
                                                                            }}
                                                                        >
                                                                            <i className="pi pi-file" style={{ fontSize: "10px", marginRight: "5px" }}></i>
                                                                            <span>{attachment.name}</span>
                                                                        </a>
                                                                    ) : ("")
                                                                    }
                                                                </div>
                                                            ))}
                                                            <br></br>
                                                        </div> </> : ("")}

                                                    {hasHTML(comment?.comment) ? (
                                                        <div
                                                            style={{ whiteSpace: "pre-wrap" }}
                                                            dangerouslySetInnerHTML={{ __html: comment.comment }}>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{ whiteSpace: "pre-wrap" }}
                                                        >
                                                            <Linkify>{comment.comment}</Linkify>
                                                        </div>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                        {hiddenCount > 0 ? (
                            <div style={{ textAlign: "left", marginTop: "-1rem", marginBottom: "1rem", color: "#6366F1", height: "24px"}}>
                                {hiddenCount} comment{hiddenCount > 1 ? "s" : ""} below
                            </div>
                        ) : (
                            <div style={{ marginTop: "-1rem", marginBottom: "1rem", height: "24px" }} />
                        )}
                        <div>
                            {/* User comments end here */}
                            {props.isExpand ? <></> :
                                <div
                                    className=" p-fluid "
                                    style={{
                                        bottom: "0",
                                        width: "100%",
                                    }}
                                >
                                    <div className="col-24 md:col-20 ">
                                        <div className="buttonIn">
                                            <div className="flex gap-2">
                                                <div style={{
                                                    width: "100%",
                                                    height: "150px"
                                                }}>
                                                    <ReactQuill
                                                        value={commentValue}
                                                        onChange={setCommentValue}
                                                        theme="snow"
                                                        style={{ height: '100px' }}  // Set the height of the editor
                                                    />

                                                </div>
                                                <div className="flex flex-column gap-1">
                                                    <div>
                                                        <Tooltip title="Expand">
                                                            <Button
                                                                className="p-button-rounded"
                                                                icon="pi pi-arrows-h"
                                                                onClick={() => {
                                                                    setAddCommentDialogVisible(true);
                                                                    setCommentValueExpand(commentValue);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                    <div className="custom-file-upload">
                                                        {attachmentfileList.length ? (
                                                            <Tooltip title="Clear Attachment">
                                                                <Button
                                                                    icon="pi pi-undo"
                                                                    className="p-button-rounded p-button-secondary"
                                                                    aria-label="Clear"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setAttachmentFileList([]);
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        ) : (
                                                            <Tooltip title="Attachment">
                                                                <Upload
                                                                    accept=".jpeg, .jpg, .png, .zip, .pdf"
                                                                    multiple
                                                                    showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                                                                    fileList={attachmentfileList}
                                                                    beforeUpload={(file) => {
                                                                        setAttachmentFileList((prev) => [...prev, file]);
                                                                        return false; // Prevent automatic upload
                                                                    }}
                                                                >
                                                                    <Button
                                                                        icon="pi pi-paperclip"
                                                                        className="p-button-rounded"
                                                                        aria-label="Upload"
                                                                        disabled={false} // Set your custom logic here if needed
                                                                    />
                                                                </Upload>
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Tooltip title="Send">
                                                            <Button
                                                                className="p-button-rounded"
                                                                icon="pi pi-send"
                                                                onClick={() => handleCommentSave(commentValue)}
                                                                disabled={
                                                                    commentValue.length ||
                                                                        attachmentfileList.length > 0
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header="Add Comment"
                visible={addCommentDialogVisible}
                modal
                style={{ width: "50vw" }}
                breakpoints={{ "960px": "75vw" }}
                onHide={() => {
                    setAddCommentDialogVisible(false);
                    setCommentValue(commentValueExpand);
                }}
            >
                <div className="flex gap-2">
                    <div style={{
                        width: "100%",
                        height: "650px"
                    }}>
                        <ReactQuill
                            value={commentValueExpand}
                            onChange={setCommentValueExpand}
                            theme="snow"
                            style={{ height: '600px' }}  // Set the height of the editor
                        />
                    </div>
                    <div className="flex flex-column gap-1">
                        <div className="custom-file-upload">
                            {attachmentfileList.length ? (
                                <Tooltip title="Clear Attachment">
                                    <Button
                                        icon="pi pi-undo"
                                        className="p-button-rounded p-button-secondary"
                                        aria-label="Clear"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setAttachmentFileList([]);
                                        }}
                                    />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Attachment">
                                    <Upload
                                            accept=".jpeg, .jpg, .png, .zip, .pdf"
                                            multiple
                                            showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                                            fileList={attachmentfileList}
                                            beforeUpload={(file) => {
                                                setAttachmentFileList((prev) => [...prev, file]);
                                                return false; // Prevent automatic upload
                                            }}

                                        >
                                        <Button
                                            icon="pi pi-paperclip"
                                            className="p-button-rounded"
                                            aria-label="Upload"
                                            disabled={
                                                attachmentfileList.length
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </Upload>
                                </Tooltip>
                            )}
                        </div>
                        <div>
                            <Tooltip title="Send">
                                <Button
                                    className="p-button-rounded"
                                    icon="pi pi-send"
                                    onClick={() => handleCommentSave(commentValueExpand)}
                                    disabled={
                                        commentValueExpand.length ||
                                            attachmentfileList.length > 0
                                            ? false
                                            : true
                                    }
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Comments"
                visible={showListCommentDialogVisible}
                modal
                style={{ width: "50vw", height: "75vh" }}
                breakpoints={{ "960px": "75vw" }}
                onHide={() => {
                    document.body.style.overflow = "visible";
                    setShowListCommentDialogVisible(false);
                }}
            >
                <CommentComponent
                    height="100%"
                    currentUser={props.currentUser}
                    projectComments={props.projectComments}
                    feedback={props.feedback}
                    project={props.project}
                    fetchProject={props.fetchProject}
                    toast={props.toast}
                    permissions={props.permissions}
                    isExpand={true}
                    commentToFocus={commentToFocus}>
                </CommentComponent>
            </Dialog>
        </React.Fragment>
    )
}

export default CommentComponent
